import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { OnboardingSteps } from "../../../utils/constants";
import { STORED_ATOM_KEYS } from "../constants";

const onboardingStepSessionStorageJson = createJSONStorage<OnboardingSteps>(
  () => sessionStorage
);

export const signUpStepAtom = atom<OnboardingSteps>(
  OnboardingSteps.SET_EARNINGS_GOALS
);

export const onboardingStepAtom = atomWithStorage<OnboardingSteps>(
  STORED_ATOM_KEYS.ONBOARDING_STEP,
  OnboardingSteps.SET_EARNINGS_GOALS,
  onboardingStepSessionStorageJson,
  { getOnInit: true }
);
onboardingStepAtom.debugLabel = "onboarding-step-atom-stored";
